export function Loader() {
  return (
    <div className="stepform-loader">
      <img src="/_resources/themes/worksafe/images/three-dots.svg" alt="" />
    </div>
  );
}
